import styled from "styled-components";

const Style = styled.div`
  background: #F9FAFB;
  display: flex;
  gap: 7px;
  padding: 4px 10px;
  border-radius: 16px;
  width: fit-content;
  
  .legend-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .legend {
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: #BABABA;
    }
  }

  span {
    color: #BABABA;
    font-size: 12px;
  }

  &.tag-0 {
    background: #F9FAFB;
    span {color: #BABABA; }
    .legend {background: #BABABA; }
  }
  &.tag-1 {
    background: #EEFFE8;
    span {color: #7BC762; }
    .legend {background: #7BC762; }
  }
  &.tag-2 {
    background: #FFFAEB;
    span {color: #F8AB38; }
    .legend {background: #F8AB38; }
  }
  &.tag-3 {
    background: #FEF6EE;
    span {color: #E87C40; }
    .legend {background: #E87C40; }
  }
  &.tag-4 {
    background: #FFF4ED;
    span {color: #CF5439; }
    .legend {background: #CF5439; }
  }
  &.tag-5 {
    background: #FEF3F2;
    span {color: #B9362D; }
    .legend {background: #B9362D; }
  }
`;

const getRoundScore = (value, type) => {
  if (type === 'SUPPLY_CHAIN_RISK') {
    const _val = value / 20;
    return Math.round(_val);
  }

  return Math.round(value);
}

export default function RiskTag({ t = (s) => s, value, type }) {
  const roundScore = getRoundScore(value, type);

  const _renderLabel = () => {
    switch (roundScore) {
      case 5:
        return t('Very High');
      case 4:
        return t('High');
      case 3:
        return t('Medium');
      case 2:
        return t('Low');
      case 1:
        return t('Very Low');
      default:
        return t('None');
    }
  };

  return (
    <Style className={`tag-${roundScore}`}>
      <div className="legend-cont">
        <div className="legend" />
      </div>
      <span>{_renderLabel()}</span>
    </Style>
  );
}
